import { styled, Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';

import type { HeaderProps } from './Header.types';

export function Header({ children, ...props }: HeaderProps) {
  return (
    <HeaderContainer variant="h3" component="h2" {...props}>
      {children}
    </HeaderContainer>
  );
}

const HeaderContainer = styled(Typography)<TypographyProps>(({ theme }) => ({
  lineHeight: 1.3,
  color: theme.tokens.bottomSheetValueHeader,
  fontWeight: theme.typography.fontWeightMedium,
  textAlign: 'center',
  padding: theme.spacing(4, 0),
}));
